import {
  post,
  get,
  put,
  _delete,
} from '@/lin/plugins/axios'

const _baseUri = 'plugin/xy/setting/'

class Settings {
  async getGlobal() {
    const res = await get(`${_baseUri}global`)
    return res
  }
  
  async updateGlobal(info) {
    const res = await put(`${_baseUri}global`, info)
    return res
  }
}

export default new Settings()